
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-575c327e\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector?type=styles&index=0!./Pagination.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./Pagination.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-575c327e\"}!../../vue-loader/lib/selector?type=template&index=0!./Pagination.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-pagination/src/Pagination.vue
// module id = 197
// module chunks = 1